import { useProfile } from '../../../../context/profile/ProfileContext';
import SubscriptionCurrentPlanCard from './sections/SubscriptionCurrentPlanCard';
import SubscriptionChangePlanCard from './sections/SubscriptionChangePlanCard';
import SubscriptionPaymentMethodCard from './sections/SubscriptionPaymentMethodCard';
import SubscriptionGstCard from './sections/SubscriptionGstCard';
import SubscriptionInvoiceEmailCard from './sections/SubscriptionInvoiceEmailCard';
import SubscriptionManageCard from './sections/SubscriptionManageCard';
import SubscriptionPaymentHistoryTable from './sections/SubscriptionPaymentHistoryTable';

const SubscriptionTab = () => {
  const { subscription, subscriptionLoading } = useProfile();

  return (
    <div className="space-y-8">
      {subscriptionLoading && !subscription ? (
        <div className="flex flex-col items-center justify-center py-20">
          <div className="w-8 h-8 border-4 border-[#067978] border-t-transparent rounded-full animate-spin"></div>
          <p className="mt-4 text-xs font-bold text-slate-400">Loading subscription details...</p>
        </div>
      ) : (
        <div className="space-y-6">
          {/* 2-Column Grid for Plan Details & Actions */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Left Column: Plan Info, Usage, Change Plan, Payment Method */}
            <div className="lg:col-span-2 space-y-5 sm:space-y-6">
              <SubscriptionCurrentPlanCard />
              <SubscriptionChangePlanCard />
              <SubscriptionPaymentMethodCard />
            </div>

            {/* Right Column: GST Details, Invoices Sent, Manage Subscription */}
            <div className="space-y-5 sm:space-y-6">
              <SubscriptionGstCard />
              <SubscriptionInvoiceEmailCard />
              <SubscriptionManageCard />
            </div>
          </div>

          {/* Billing & Invoice History Table */}
          <SubscriptionPaymentHistoryTable />
        </div>
      )}
    </div>
  );
};

export default SubscriptionTab;
